var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31465 5.92365H9.47155V7.49615C9.9263 6.59175 11.0925 5.77915 12.8444 5.77915C16.2027 5.77915 17 7.57945 17 10.8826V17H13.6V11.6348C13.6 9.75375 13.1453 8.69295 11.9876 8.69295C10.3819 8.69295 9.71465 9.8362 9.71465 11.634V17H6.31465V5.92365ZM0.4845 16.8555H3.8845V5.77915H0.4845V16.8555ZM4.37155 2.1675C4.37168 2.45248 4.31516 2.73465 4.20528 2.9976C4.0954 3.26055 3.93435 3.49904 3.7315 3.6992C3.32044 4.10773 2.76404 4.33641 2.1845 4.335C1.60598 4.33461 1.05086 4.10652 0.6392 3.70005C0.43708 3.49921 0.276578 3.26045 0.166892 2.99747C0.0572062 2.73448 0.000492262 2.45244 0 2.1675C0 1.59205 0.2295 1.04125 0.64005 0.63495C1.05135 0.227935 1.6067 -0.000254329 2.18535 2.12725e-07C2.76505 2.12725e-07 3.32095 0.22865 3.7315 0.63495C4.1412 1.04125 4.37155 1.59205 4.37155 2.1675Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.578fc6f5c8156aef6cc1c4338233cf32.svg";
export { ForwardRef as ReactComponent };